import { Box, Skeleton } from '@mui/material';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { PatientVerificationSummary } from '../../../../services/insurance/types/patient-verification-summary';
import { VerificationPriority } from '../../../../services/insurance/types/verification-priority';
import { VerificationSummary } from '../../../../services/insurance/types/verification-summary';
import { StatusText, StatusWrapper } from '../../shared/styles';

export interface PatientIvStatusButtonProps {
  text: string;
  icon: React.ReactNode;
  selectedIvSummary?: VerificationSummary;
  patientFlow?: {
    patientIvSummary: PatientVerificationSummary;
    verificationPriority: VerificationPriority;
  };
}

export const PatientIvStatusButton: FC<PatientIvStatusButtonProps> = (props): React.ReactElement => {
  const { text, selectedIvSummary, patientFlow, icon } = props;
  const { publish } = useEventBus();
  const [isLoading, setIsLoading] = useState(false);

  const handlePatientFlowClick = () => {
    if (!patientFlow || !selectedIvSummary) return;

    setIsLoading(true);

    publish({
      messageType: 'ivShowVerificationDialog',
      data: {
        locationId: patientFlow.patientIvSummary.locationId,
        patientId: patientFlow.patientIvSummary.patientId,
        priority: patientFlow.verificationPriority
      }
    });

    setTimeout(() => setIsLoading(false), 1000);
  };

  return (
    <>
      <StatusWrapper className="status-wrapper">
        {icon}
        <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: '8px' }}>
          {isLoading && <Skeleton height={20} width={120} />}
          {!isLoading && <StatusText onClick={handlePatientFlowClick}>{text || 'Unknown'}</StatusText>}
        </Box>
      </StatusWrapper>
    </>
  );
};
